export default "__VITE_ASSET__sFIgESaE__"